import { useI18n } from 'next-localization';
import { S02FindALocationProps } from './S02FindALocation.types';
import { FindALocationProps } from '@ahc-digital/component-library';

export function CreateFindALocationModel(
  props: S02FindALocationProps | undefined,
  LocationSearchURL: string,
  options: Record<string, string[]>
): Omit<FindALocationProps, 'googleMapsAPIKey'> {
  const { t } = useI18n() || {};
  const { fields } = props || {};
  return {
    locationInputPlaceholder: t('FindALocation-CityStateZip'),
    locationTypeLabel: t('FindALocation-SelectALocation'),
    locationTypeItems: Object.values(options).flat(),
    searchUrl: LocationSearchURL,
    filterType: fields?.FilterType?.value as FindALocationProps['filterType'],
    getPreciseLocationTriggerTitle: t('FindALocation-GetPreciseLocationTriggerTitle'),
    legendLabel: t('FindALocation-LegendLabel'),
    locationInvalidErrorMessage: t('FindALocation-LocationValidationText'),
    locationRequiredErrorMessage: t('FindALocation-LocationRequiredErrorMessage'),
    searchAPIErrorMessage: t('FindALocation-SearchAPIErrorMessage'),
    submitButtonTitle: t('FindALocation-SubmitButtonTitle'),
  };
}
